import { type FC, type ReactNode } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

import Button from "~/components/Button"

type Props = {
	children: ReactNode
	onClose: () => void
	className?: string
	contentClassName?: string
}
const EditorShell: FC<Props> = ({ children, onClose, className, contentClassName }) => (
	<div
		className={cn(
			"min-h-0 w-full overflow-hidden border border-indigo-200/80 bg-white text-gray-900 ring-1 ring-indigo-100/80",
			className,
		)}
		data-inline-editor
	>
		<div className={cn("min-h-0", contentClassName)}>{children}</div>
		<footer className="sticky bottom-0 mx-auto flex max-w-7xl flex-wrap items-center justify-end gap-3 border-t border-black/5 bg-white/95 px-6 py-4 backdrop-blur">
			<Button variant="secondary" onClick={onClose} className="cursor-pointer">
				Close
			</Button>
		</footer>
	</div>
)

export default EditorShell
